import React from 'react';
import Select from 'react-select';
import FormControl from 'react-bootstrap/FormControl';
import { FaTimes } from 'react-icons/fa';


class ColdTextFilter extends React.Component {
  static conditionOptions = [
    { value: "equals", label: "Equals" },
    { value: "not-equals", label: "Not Equals" },
    { value: "in", label: "Contains" },
    { value: "not-in", label: "Does Not Contains" },
    { value: "empty", label: "Empty" },
    { value: "not-empty", label: "Not Empty" },
    { value: "start-with", label: "Starts with" },
    { value: "end-with", label: "Ends with" },
  ];

  constructor(props) {
    super(props);
    const f = props.filter;
    const condition = f
      ? ColdTextFilter.conditionOptions.find((c) => c.value === f.condition) ||
        null
      : ColdTextFilter.conditionOptions[2];
    this.state = {
      condition,
      value: f ? f.value : "",
    };
  }

  componentDidUpdate(prevProps) {
    // Reset child state when parent clears filters
    if (prevProps.filter && !this.props.filter) {
      this.setState({ condition: null, value: "" });
    }
  }

  onConditionChanged = (select) => {
    const noValue = select.value === "empty" || select.value === "not-empty";
    this.setState({
      condition: select,
      value: noValue ? "" : this.state.value,
    });

    if (noValue) {
      this.props.onValueChange(this.props.field.field_key, select.value, "");
    } else {
      // condition changed but no value yet — remove filter until value typed
      // this.props.deleteFilter(this.props.field.field_key);
    }
  };

  handleTextChange = (e) => {
    const value = e.target.value;
    this.setState({ value });
    if (this.state.condition) {
      this.props.onValueChange(
        this.props.field.field_key,
        this.state.condition.value,
        value,
      );
    }
  };

  onReset = () => {
    this.setState({ condition: null, value: "" });
    this.props.resetFilter(this.props.field.field_key);
  };

  render() {
    const { field } = this.props;
    const { condition, value } = this.state;
    const conditionValue = condition ? condition.value : "";
    const noValueNeeded =
      conditionValue === "empty" || conditionValue === "not-empty";

    // Show reset icon when filter is active (has value, or condition needs no value)
    const isActive = (value && value.length > 0) || noValueNeeded;

    return (
      <>
        <div className="row pt-2">
          <div className="col-md-5">
            <p className="headingp">{field.label_name}</p>
          </div>
          <div className={`col-md-${isActive ? 5 : 7}`}>
            <Select
              value={condition}
              onChange={this.onConditionChanged}
              options={ColdTextFilter.conditionOptions}
              isSearchable={true}
              placeholder="Select..."
            />
          </div>
          {isActive && (
            <div className="col-md-1">
              <FaTimes style={{ cursor: "pointer" }} onClick={this.onReset} />
            </div>
          )}
        </div>

        {condition && !noValueNeeded && (
          <div className="row pt-2">
            <div className="col-md-12">
              <FormControl
                type={field.field_type === "number" ? "number" : "text"}
                placeholder="Value"
                value={value}
                onChange={this.handleTextChange}
                className="mr-sm-2"
              />
            </div>
          </div>
        )}
        <hr />
      </>
    );
  }
}

export default ColdTextFilter;